import { motion } from "framer-motion"
import coppi from "../assets/coppi.png"
import feg from "../assets/feg.png"
import kniese from "../assets/kniese.png"
import orwell from "../assets/orwell.png"
import satp from "../assets/satp.png"

const logos = [
  { src: coppi, alt: "Hans-und-Hilde-Coppi-Gymnasium" },
  { src: orwell, alt: "George-Orwell-Schule" },
  { src: kniese, alt: "Paul-und-Charlotte-Kniese-Schule" },
  { src: satp, alt: "Schule am Tierpark" },
  { src: feg, alt: "Friedrich-Ebert-Gymnasium" },
]

export function Partners() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-gradient-to-tr from-black/10 to-transparent blur-3xl" />
        <div className="absolute -right-24 top-32 h-72 w-72 rounded-full bg-gradient-to-tr from-gray-400/20 to-transparent blur-3xl" />
      </div>

      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 space-y-12">
        {/* Logos */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 items-center">
          {logos.map((logo, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="flex items-center justify-center rounded-2xl border p-8 bg-white/40 backdrop-blur hover:bg-white/60 transition">
              <img src={logo.src} alt={logo.alt} className="max-h-16 w-auto object-contain transition" />
            </motion.div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="text-center text-sm text-gray-500">Aktuell im Aufbau mit ausgewählten Partnerschulen</div>
      </div>
    </section>
  )
}
